import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { UserProvider, useUser } from "./Context/UserContext"; // Importamos el UserProvider
import { AuthProvider } from "./Context/AuthContext"; // Importamos el AuthProvider

import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductView from "./pages/ProductView";
import SignInPage from "./pages/LoginAcc";
import CreateAcc from "./pages/CreateAcc";
import ProfilePage from "./pages/ProfilePage";
import Insignia from "./pages/Insignia";
import KitsView from "./pages/KitsView";
import SupESP from "./pages/ProductosInsignia/SuperiorESP";
import { AsociaLoginForm } from "./pages/AsociaLogIn";
import { AsociaAdmin } from "./pages/AsociaAdmin";
import KitMecaAnalogico from "./pages/Kits/Meca/KitAnal";
import KitDigitalesMeca from "./pages/Kits/Meca/KitDigital";
import KitMecaCCCA from "./pages/Kits/Meca/KitCCCA";
import KitMedicionesElectro from "./pages/Kits/Electro/KitMediciones";
import CheckoutForm from "./pages/Kits/CheckoutForm";
import OrderConfirmation from "./pages/Kits/OrderConfirmation";
import KitCircuitosCE from "./pages/Kits/Compu/KitCircuitos";
import UNOR4 from "./pages/ProductosInsignia/UNOR4";
import UNOR3 from "./pages/ProductosInsignia/UNO R3";
import KitsArduino from "./pages/ProductosInsignia/KitsArduino";
import PCB from "./pages/ServicesFront/PCB";
import Volteon from "./pages/Volteon";
import SemanaVolteon from "./pages/SemanaVolteon"
import PuntosVenta from "./pages/PuntosVenta";
import Reembolso from "./pages/Reembolso";
import Envios from "./pages/Envios"; 
import HomeServices from "./pages/homeServices";
import RegistroIntermedio from "./pages/CreateAccIntermediate";
import PagoConfirmacion from "./pages/Kits/CardConfirmation";
import Tutorial from "./components/TutorialComponents/tutorial";
import TutorialesTut from "./components/TutorialComponents/tutoriales_tut";
import ProductosTut from "./components/TutorialComponents/productos_tut";
import TalleresTut from "./components/TutorialComponents/talleres_tut";
import Aurora from './components/Aurora/Aurora';
import Electricborder from "./components/ElectricBorder/ElectricBorder";


function App() {
  return (
      <>
        <div className="app-aurora-background">
          <Aurora
              colorStops={['#06B6D4', '#7C3AED', '#0057ad']}
              amplitude={0.9}
              blend={0.55}
              speed={0.3}
          />
        </div>
    <AuthProvider>
      <UserProvider>
        <Router>
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/iniciar-sesion" exact element={<SignInPage />} />
            <Route path="/crear-cuenta" exact element={<CreateAcc />} />
            <Route path="/registro-intermedio" element={<RegistroIntermedio />} />
            <Route path="/perfil" exact element={<ProfilePage />} />
            <Route path="/SemanaVolteon" element={<SemanaVolteon />} />
            <Route path="/PuntosdeVenta" element={<PuntosVenta />} />
            <Route path="/reembolso" element={<Reembolso />} />
            <Route path="/envios" element={<Envios />} />


            <Route path="/catalogo" element={<Products />} />
            <Route path="/products/:id" element={<ProductView />} />

            {/* SERVICIOS Y SUS LINKS*/}
            <Route path="/servicios" element={<HomeServices />} />
            <Route path="/servicios/PCB" element={<PCB />} />
            <Route path="/servicios/PCB/confirmation" element={<Home />} />
            <Route path="/servicios/PCB/checkout" element={<Home />} />

            <Route path="/Volteon" element={<Volteon />} />
            <Route path="/asocias" element={<AsociaLoginForm />} />
            <Route path="/asocias/admin" element={<AsociaAdmin />} />

            {/* PRODUCTOS INSIGINA Y SUS LINKS*/}
            <Route path="/insignia" element={<Insignia />} />
            <Route path="/insignia/Superior" element={<SupESP />} />
            <Route path="/insignia/UNOR4" element={<UNOR4 />} />
            <Route path="/insignia/UNOR3" element={<UNOR3 />} />
            <Route path="/insignia/kitsArduino" element={<KitsArduino />} />

            {/* KITS Y SUS LINKS*/}
            <Route path="/kits" element={<KitsView />} />
            <Route path="/kits/analogica" element={<KitMecaAnalogico />} />
            <Route path="/kits/digital" element={<KitDigitalesMeca />} />
            <Route path="/kits/ccca" element={<KitMecaCCCA />} />
            <Route path="/kits/mediciones" element={<KitMedicionesElectro />} />
            <Route path="/kits/circuitosCE" element={<KitCircuitosCE />} />
            <Route path="/kits/checkout" element={<CheckoutForm />} />
            <Route path="/kits/confirmation" element={<OrderConfirmation />} />
            <Route path="/kits/pago-confirmacion" element={<PagoConfirmacion />} />

            {/* Tutoriales y sus links */}
            <Route path="/tutorial" element={<Tutorial />} />
            <Route path="/tutorial/tutoriales" element={<TutorialesTut />} />
            <Route path="/tutorial/talleres" element={<TalleresTut />} />
            <Route path="/tutorial/productos" element={<ProductosTut />} />

          </Routes>
        </Router>
      </UserProvider>
    </AuthProvider>
      </>
  );
}
export default App;
